<span [ngClass]="parentClass">
    <textarea [rows]="rows" nz-input [(ngModel)]="question.answer[0]" (ngModelChange)="validateAnswer()"
        [placeholder]="(textField?.option  | dynamicTranslate | async ) || 'Type your answer here...'"></textarea>

    <ng-container *ngIf="!question?.valid">
        <nz-alert nzType="error" [nzMessage]="textField?.validation?.errorMessage"></nz-alert>
    </ng-container>
</span>